<h3 class="text-md py-4 font-bold">Cylinder Oil Consumption</h3>

<form
  #form="ngForm"
  novalidate
>
  <div class="flex flex-col gap-1">
    <nsp-select-input
      id="oilCode"
      name="oilCode"
      label="CLO Lubrication Code"
      [options]="OIL_CODE_OPTIONS"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilCode')"
      [readonly]="isFieldReadOnly('oilCode')"
      [value]="consumptionsStore.cylinderOilConsumption().oilCode.value"
      [ngModel]="consumptionsStore.cylinderOilConsumption().oilCode.value"
    />
    <nsp-number-input
      id="oilBn"
      name="oilBn"
      label="CLO BN"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilBn')"
      [readonly]="isFieldReadOnly('oilBn')"
      [value]="consumptionsStore.cylinderOilConsumption().oilBn.value"
      [ngModel]="consumptionsStore.cylinderOilConsumption().oilBn.value"
    />
    <nsp-number-input
      id="oilDensityAt15"
      name="oilDensityAt15"
      label="Density at 15°C"
      [unit]="units.kilogramsPerCubicMeter"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilDensityAt15')"
      [readonly]="isFieldReadOnly('oilDensityAt15')"
      [value]="consumptionsStore.cylinderOilConsumption().oilDensityAt15.value"
      [ngModel]="
        consumptionsStore.cylinderOilConsumption().oilDensityAt15.value
      "
    />
    <nsp-number-input
      name="oilTankTemperature"
      id="'oilTankTemperature"
      label="CLO Tank Temperature"
      [unit]="units.degreesCelsius"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilTankTemperature')"
      [readonly]="isFieldReadOnly('oilTankTemperature')"
      [value]="
        consumptionsStore.cylinderOilConsumption().oilTankTemperature.value
      "
      [ngModel]="
        consumptionsStore.cylinderOilConsumption().oilTankTemperature.value
      "
    />
    <nsp-number-input
      name="oilConsumption"
      id="oilConsumption"
      label="Actual Consumption"
      [unit]="units.liters"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilConsumption')"
      [readonly]="isFieldReadOnly('oilConsumption')"
      [value]="consumptionsStore.cylinderOilConsumption().oilConsumption.value"
      [ngModel]="
        consumptionsStore.cylinderOilConsumption().oilConsumption.value
      "
    />
    <nsp-number-input
      [name]="'oilKgConsumption'"
      [id]="'oilKgConsumption'"
      label="Actual Consumption"
      [unit]="units.kilograms"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilKgConsumption')"
      [readonly]="isFieldReadOnly('oilKgConsumption')"
      [value]="consumptionsStore.vm().cylinderOilKgConsumption"
      [ngModel]="consumptionsStore.vm().cylinderOilKgConsumption"
    />
    <nsp-number-input
      [name]="'oilSloc'"
      [id]="'oilSloc'"
      label="SLOC"
      [unit]="units.gramsPerKilowattHour"
      [labelWidthPercentage]="33"
      [required]="isFieldRequired('oilSloc')"
      [readonly]="isFieldReadOnly('oilSloc')"
      [value]="consumptionsStore.vm().cylinderOilSloc"
      [ngModel]="consumptionsStore.vm().cylinderOilSloc"
    />
  </div>
</form>
